import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
  getTextFilterCfg,
  getFormatterForKodif,
  getEditIconColumn, getmultiSelectFilterCfg
} from '../grid/ColumnHelpers'
import {
    Button, 
    UncontrolledButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle, 
    Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';

import Form, {DateInputField} from '../forms/Form'
import * as constants from '../../constants'
import Karte from '../karte/IzraktenisMap';
import * as maputils from '../karte/maputils'
import { isEmptyValue } from '../forms/FormHelpers'

import SplitterLayout from 'react-splitter-layout';
import Link from 'redux-first-router-link';

import {saveAtskaite, goToAtskaites} from '../../actions/atskaiteActions'
import {guiSet} from '../../actions/uiActions'
import {virszemesUdensObjektsSelected, virszemesUdensObjektsDoubleSelected} from '../../actions/virszemesUdensObjektiActions'

import Grid from '../grid/Grid'
import BBoxFilterButtonToUrl from '../grid/BBoxFilterButtonToUrl'
import ArchivedFilterButtonToUrl from '../grid/ArchivedFilterButtonToUrl'
import { useEffect } from 'react';

const editIconColumn = getEditIconColumn((row) => (
    {
        type: 'loc_virszemes_udens_objekts',
        payload: {
            kods: row.kods
        }
    }
    )
)

const atskaiteMinDate = 2006;

const atskaiteFrmFieldCfgs = ({kodif, setDateField}) => {
  const createCustomDateField = (fieldName, fieldLabel) => ({
    name: fieldName,
    label: fieldLabel,
    required: true,
    validation: (values) => {
      const currentVal = values[fieldName];
      if (currentVal < atskaiteMinDate) {
        return `Nedrīkst būt mazāks par ${atskaiteMinDate}`;
      }
      if (!isEmptyValue(values.gads_no) && !isEmptyValue(values.gads_līdz) && values.gads_no > values.gads_līdz) {
        return "Gads 'No' nedrīkst būt lielāks par gadu 'Līdz'";
      }


      return null
    },
    customField: (props) => {
      const { currentVal, setFieldValue } = props
      const yearToDate = (year) => {
        if (year) {
          const d = new Date(year, 0, 1);
          return d;
        }
        return null;
      }
      const dateToYear = (date) => {
        if (date) {
          const year = date.getFullYear();
          return year;
        }
        return null;
      }
      const newSetFieldValue = (fieldName, value) => setFieldValue(fieldName, dateToYear(value));

      return <DateInputField
        fieldName={fieldName}
        currentVal={yearToDate(currentVal)}
        setFieldValue={newSetFieldValue}
        extraFieldProps={{
          placeholder: fieldLabel,
          dateFormat: constants.YEAR_FORMAT,
          showYearPicker: true,
          popperContainer: ({ children }) => <div>{children}</div>,
          showTimeSelect: false
        }}
      />;
    }
  });

  return [
    createCustomDateField("gads_no", "No"),
    createCustomDateField("gads_līdz", "Līdz"),
  ]
};

const kvalitatesMerkiFrmFieldCfgs = ({ values = {}, setFieldValue, fetchAct, selectedItem, kodif } = {}) => {
  const periods_garums = 6;
  const baseYear = 2016;

  const currentYear = new Date().getFullYear();

  const defaultValue =
    values.gads_periods ||
    selectedItem?.periods ||
    (() => {
      const start = baseYear + Math.floor((currentYear - baseYear) / periods_garums) * periods_garums;
      return `${start}-${start + periods_garums - 1}`;
    })();

  const PeriodSelector = (props) => {
    const { currentVal, setFieldValue } = props;
    const selectedValue = currentVal || defaultValue;

    useEffect(() => {
      if (!currentVal && setFieldValue) {
        setFieldValue('gads_periods', defaultValue);
      }
    }, [currentVal, setFieldValue]);

    const parsePeriod = (period) => {
      const [start] = period.split('-').map(Number);
      return start;
    };

    const formatPeriod = (start) => `${start}-${start + periods_garums - 1}`;

    const updateValue = (val) => {
      if (setFieldValue) setFieldValue('gads_periods', val);
      if (fetchAct && selectedItem) fetchAct({ ...selectedItem, periods: val });
    };

    const nextYear = () => formatPeriod(parsePeriod(selectedValue) + periods_garums);
    const prevYear = () => formatPeriod(parsePeriod(selectedValue) - periods_garums);

    return (
      <div className="d-flex align-items-center justify-content-center mt-2">
        <i
          className="fa fa-caret-left"
          title={prevYear()}
          onClick={() => updateValue(prevYear())}
        />
        <span className="mx-4">{selectedValue}</span>
        <i
          className="fa fa-caret-right"
          title={nextYear()}
          onClick={() => updateValue(nextYear())}
        />
      </div>
    );
  };

  return [
    {
      name: 'gads_periods',
      label: 'Gadu periodi',
      defaultValue,
      customField: PeriodSelector
    }
  ];
};

const getColumns = ({kodif}) => {
  return [editIconColumn, {
    dataField: 'kods',
    text: 'Kods',
    width: 176,
    filterCfg: getTextFilterCfg()
  }, {
    dataField: 'nosaukums',
    text: 'Nosaukums',
    width: 235,
    filterCfg: getTextFilterCfg()
  }, {
    dataField: 'adm_teritorija',
    text: 'Adm. teritorija',
    filterCfg: getTextFilterCfg()
  }, {
    dataField: 'uo_tips',
    text: 'Tips',
    width: 220,
    filterCfg: getmultiSelectFilterCfg(kodif.UO_TIPS)
  }, {
    dataField: 'kategorija',
    text: 'Kategorija',
    formatter: getFormatterForKodif(kodif.virszemesUdensObjektaKategorija),
    width: 120,
    filterCfg: getmultiSelectFilterCfg(kodif.virszemesUdensObjektaKategorija)
  }, {
    dataField: 'izcelsme',
    text: 'Izcelsme',
    formatter: getFormatterForKodif(kodif.udensObjektaIzcelsme),
    width: 120,
    filterCfg: getmultiSelectFilterCfg(kodif.udensObjektaIzcelsme)
  }]
};

class VirszemesUdensObjekti extends Component {
    constructor(props) {
      super(props);
      this.state = {
        modalSearch: false,
        exportPopup: false,
        goToAtskaitePopup: false,
      };
    }

    openModalExport = (type) => {
      this.setState({
        exportPopup: true,
        goToAtskaitePopup: false,
        exportType: type,
        atskaite: {
          kods: type,
          gads_no: null,
          gads_līdz: null,
          gads_periods: ''
        }
      });
    };

    closeModalExport = () => {
      this.setState({
        exportPopup: false,
        goToAtskaitePopup: false,
      });
    };

    toggleModalSearch = () => {
      this.setState({
        modalSearch: !this.state.modalSearch
      });
    }

    toggleGoToAtskaitePopup = () => {
      this.setState({
        goToAtskaitePopup: !this.state.goToAtskaitePopup
      });
    }

    setDateField = (fieldName, value) => {
      this.setState({
        atskaite: {
          ...this.state.atskaite,
          [fieldName]: value
        }
      });
    }

    mapPaneSizeChange = (h) => {
      this.props.guiSet('udeni_saraksts_karte_height', h);
    }

    rowEvents = {
      onDoubleClick: (e, row, rowIndex) => {
        this.props.udensObjektsDoubleSelected(row.kods)
      }
    }

    render() {
      const atskaiteRole = this.props.user && this.props.user.tiesibas.includes('ATSKAITE_LIETOT')

      const vectorLayerCfgs = {
        virszemesUdensObjektiLabels : {
          title: `Ūdensobjektu nosaukumi`,
          features: this.props.virszemesUdensObjekti.list,
          styles: maputils.uoStyles.uoLabelsStyle,
          selected: this.props.virszemesUdensObjekti.selected,
          zIndex: 6,
          declutter: true
        },
        virszemesUdensObjekti : {
          title: 'Ūdensobjekti',
          features: this.props.virszemesUdensObjekti.list,
          styles: maputils.uoStyles.uoStyle,
          tooltipFunc: (feat) => `${feat.get('nosaukums')} (${feat.get('kods')})`,
          selected: this.props.virszemesUdensObjekti.selected,
          legend: {
            features: [
              {
                label: 'Ūdensobjekts',
                geomType: 'polygon',
                selected: false
              },
              {
                label: 'Ūdensobjekts (izvēlēts)',
                geomType: 'polygon',
                selected: true
              }
            ]
          },
          zIndex: 5
        }
      }

      if(!this.columns){
        this.columns = getColumns({
          kodif: this.props.kodif
        })
      }

      if(!this.atskaiteFields){
        this.atskaiteFields = atskaiteFrmFieldCfgs({
          kodif: this.props.kodif,
          setDateField: this.setDateField
        })
      }

      if (!this.kvalitatesMerkiFields) {
        this.kvalitatesMerkiFields = kvalitatesMerkiFrmFieldCfgs({
          setFieldValue: this.setDateField
        });
      }

      return (
        <>
          <SplitterLayout
            vertical
            percentage
            primaryIndex={1}
            secondaryInitialSize={this.props.gui.udeni_saraksts_karte_height}
            onSecondaryPaneSizeChange={this.mapPaneSizeChange}>
            <Karte mapId="udens_objekti_saraksts" vectorLayerCfgs={vectorLayerCfgs} />

            <Grid
              onRowSelected={this.props.udensObjektsSelected}
              loading={this.props.virszemesUdensObjekti.loading}
              selectedId={this.props.virszemesUdensObjekti.selected}
              dataList={this.props.virszemesUdensObjekti.list}
              totalCount={this.props.virszemesUdensObjekti.count}
              columns={this.columns}
              rowEvents={this.rowEvents}
              enablePaging={false}
            >
              { this.props.user.tiesibas.includes('BAIS_VU_PAMAT_LABOT') ? (
                <Link to={{ type: 'loc_virszemes_udens_objekts',
                  payload: {
                        kods: 'jauns'
                      }
                }}>
                  <Button color="primary"><i className="fa fa-plus-circle"></i>&nbsp;&nbsp;Jauns</Button>
                </Link>
              ) : null }
              <BBoxFilterButtonToUrl/>
              <ArchivedFilterButtonToUrl/>
              {atskaiteRole ? <UncontrolledButtonDropdown>

                <DropdownToggle color="primary" caret>
                  Datu eksports
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem
                    onClick={() => this.openModalExport("virszemes_udens_objekts_kvalitate_ekologija_visi_export_ods")}
                  >
                    Ekoloģiskā kvalitāte
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => this.openModalExport("Ekologiska_kvalitate_tabulas")}
                  >
                    Ekoloģiskā kvalitāte (vairākas lapas)
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => this.openModalExport("virszemes_udens_objekts_kvalitate_kimiska_visi_export_ods")}
                  >
                    Ķīmiskā kvalitāte
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => this.openModalExport("virszemes_udens_objekts_kvalitate_kimiska_pivot_export_ods")}
                  >
                    Ķīmiskā kvalitāte UBA plāniem
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => this.openModalExport("virszemes_udens_objekts_kvalitates_merki_visi_export_ods")}
                  >
                    Kvalitates mērķi
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
              : null}
            </Grid>
          </SplitterLayout>

          <Modal isOpen={this.state.goToAtskaitePopup} className="modal-lg">
            <ModalHeader>Atskaite</ModalHeader>
            <ModalBody>
              Atskaites veidošana uzsākta!
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={this.props.goToAtskaites}>Iet uz atskaišu sarakstu</Button>
              <Button color="secondary" onClick={this.toggleGoToAtskaitePopup}>Aizvērt</Button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={this.state.exportPopup} className="modal-sm">
              {["virszemes_udens_objekts_kvalitate_ekologija_visi_export_ods", "virszemes_udens_objekts_kvalitate_kimiska_visi_export_ods", "virszemes_udens_objekts_kvalitate_kimiska_pivot_export_ods",  "Ekologiska_kvalitate_tabulas"].includes(this.state.exportType) ? (
                <>
                  <ModalHeader>
                    Eksportēt visus ŪO {
                      this.state.exportType === "virszemes_udens_objekts_kvalitate_ekologija_visi_export_ods" ? "ekoloģisko" :
                      this.state.exportType === "Ekologiska_kvalitate_tabulas" ? "ekoloģisko (vairākas lapas)" :
                      "ķīmisko"
                    } kvalitāti
                  </ModalHeader>
                  <ModalBody className="text-center">
                    <div className="alert alert-info text-left">
                      Eksportējamie dati ir indikatīvi, un precīzos datus iespējams saņemt, vēršoties LVĢMC
                    </div>

                    <div>
                      <Form
                        onSubmit={(atskaite) => {
                          this.props.saveAtskaite(atskaite, this.toggleGoToAtskaitePopup);
                          this.closeModalExport();
                        }}
                        tiesibasLabot="BAIS_VU_PAMAT_LABOT"
                        formFieldCfgs={this.atskaiteFields}
                        metadataFormCfg="atskaite"
                        dataObj={this.state.atskaite}
                        editable={true}
                        sizeLabel={3}
                        onReset={this.closeModalExport}
                      />
                    </div>
                  </ModalBody>
                </>
              ) : this.state.exportType === "virszemes_udens_objekts_kvalitates_merki_visi_export_ods" ? (
                <>
                  <ModalHeader>Eksportēt visus ŪO kvalitātes mērķus</ModalHeader>
                  <ModalBody className="text-center">
                    <div className="alert alert-info text-left">
                      Eksportējamie dati ir indikatīvi, un precīzos datus iespējams saņemt, vēršoties LVĢMC
                    </div>

                    <div>
                      <Form
                        onSubmit={(atskaite) => {
                          if (atskaite.gads_periods) {
                            const [start, end] = atskaite.gads_periods.split('-').map(Number);
                            atskaite.gads_no = start;
                            atskaite.gads_līdz = end;
                            console.log(start, end);
                          }
                          this.props.saveAtskaite(atskaite, this.toggleGoToAtskaitePopup);
                          this.closeModalExport();
                        }}
                        tiesibasLabot="BAIS_VU_PAMAT_LABOT"
                        formFieldCfgs={this.kvalitatesMerkiFields}
                        metadataFormCfg="atskaite"
                        dataObj={this.state.atskaite}
                        editable={true}
                        sizeLabel={3}
                        onReset={this.closeModalExport}
                      />
                    </div>
                  </ModalBody>
                </>
              ) : null}
          </Modal>
        </>
      );
    }
  }
  
  const mapStateToProps = ({kodif, virszemesUdensObjekti, gui, user}) => {
    return {kodif, virszemesUdensObjekti, gui, user}
  }
  
  export default connect(mapStateToProps, {saveAtskaite: saveAtskaite, goToAtskaites: goToAtskaites, udensObjektsSelected: virszemesUdensObjektsSelected, guiSet, udensObjektsDoubleSelected: virszemesUdensObjektsDoubleSelected})(VirszemesUdensObjekti)
  